export const getAnimationClass = (effect, side, dbox) => {
	const effectMap = {
		'flip-left': 'vayu_blocks_flip-box-inner_animation_div_flip-front-left',
		'flip-right': 'vayu_blocks_flip-box-inner_animation_div_flip-front',
		'flip-top': 'vayu_blocks_flip-box-inner_animation_div_flip-back',
		'flip-bottom': 'vayu_blocks_flip-box-inner_animation_div_flip-back-bottom',
		'flip-z': 'vayu_blocks_flip-box-inner_animation_div_flip-z',
		'flip-x': 'vayu_blocks_flip-box-inner_animation_div_flip-x',
		'zoom-in': 'vayu_blocks_flip-box-inner_animation_div_zoom-in',
		'zoom-out': 'vayu_blocks_flip-box-inner_animation_div_zoom-out',
		'fade-in': 'vayu_blocks_flip-box-inner_animation_div_fade-in',
		'slide-left': 'vayu_blocks_flip-box-inner_animation_div_slide_animation-left',
		'slide-right': 'vayu_blocks_flip-box-inner_animation_div_slide_animation-right',
		'slide-top': 'vayu_blocks_flip-box-inner_animation_div_slide_animation-top',
		'slide-bottom': 'vayu_blocks_flip-box-inner_animation_div_slide_animation-bottom',
		'push-left': 'vayu_blocks_flip-box-inner_animation_div_push_animation-left',
		'push-right': 'vayu_blocks_flip-box-inner_animation_div_push_animation-right',
		'push-top': 'vayu_blocks_flip-box-inner_animation_div_push_animation-top',
		'push-bottom': 'vayu_blocks_flip-box-inner_animation_div_push_animation-bottom',
	};

	const key = ['flip', 'slide', 'push'].includes(effect) ? `${effect}-${side}` : effect;
	let innerclass = effectMap[key] || '';
	if (dbox && !['zoom-in', 'zoom-out', 'fade-in', 'slide', 'push'].includes(effect)) {
		innerclass += '-dbox';
	}
	return innerclass;
};
